<script>
import AppBanner from '@/components/shared/AppBanner';
import ProjectsCarousel from '../components/projects/ProjectsCarousel.vue';

export default {
	name: 'Home',
	components: {
		AppBanner,
		ProjectsCarousel,
	},
};
</script>

<template>
	<div class="w-full">
		<!-- Asymmetric hero with the interactive field -->
		<AppBanner />

		<!-- Projects — peeking up under the hero on desktop -->
		<section
			class="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14 pb-20 sm:pb-28"
		>
			<ProjectsCarousel />
		</section>
	</div>
</template>

<style scoped></style>
